'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = Text;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _box = require('./box');

var _box2 = _interopRequireDefault(_box);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 */
function Text(props) {
  return _react2['default'].createElement(_box2['default'], _extends({ is: 'p' }, props));
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/ui/blocks/text.js
 ** module id = 416
 ** module chunks = 0 1
 **/